import axios from 'axios';
import { API_BASE_URL, createAuthHeader } from '../../../config/api.config';

const post = async (url, payload) => {
  const token = localStorage.getItem('access_token');
  const response = await axios.post(url, payload, { headers: createAuthHeader(token) });
  return response.data;
};

export const createBulkDiscountForMachine = (clientId, payload) =>
  post(`${API_BASE_URL}/experiments/bulk/discount-machine?clientId=${clientId}`, payload);

export const createBulkDiscountForProduct = (clientId, payload) =>
  post(`${API_BASE_URL}/experiments/bulk/discount-product?clientId=${clientId}`, payload);

export const createBulkReplacement = (clientId, payload) =>
  post(`${API_BASE_URL}/experiments/bulk/replacement?clientId=${clientId}`, payload);

export const fetchBulkTargets = async (clientId, { productId } = {}) => {
  const token = localStorage.getItem('access_token');
  const params = new URLSearchParams({ clientId });
  if (productId) {
    params.set('productId', productId);
  }
  const response = await axios.get(
    `${API_BASE_URL}/experiments/bulk/targets?${params.toString()}`,
    { headers: createAuthHeader(token) }
  );
  return response.data;
};
